import { PasskeyManager } from "@/components/commons/PasskeyManager";
import { InnerBox } from "@/components/elements/InnerBox";
import { ExternalLoginSection } from "@/features/user-setting/components/detail/ExternalLoginSection";
import { PasskeyTable } from "@/features/user-setting/components/detail/PasskeyTable";
import { PasswordResetFields } from "@/features/user-setting/components/edit/PasswordResetFields";
import { TUserSettingEditForm } from "@/features/user-setting/types/userSettingEditForm";
import { divider } from "@/theme/colors";
import { Divider, Stack } from "@mui/material";
import { FC } from "react";
import { Control } from "react-hook-form";

type TSecuritySettingsEditSectionProps = {
  control: Control<TUserSettingEditForm>;
  googleConnected?: boolean;
  googleEmail?: string | null;
  hasPassword: boolean;
};

export const SecuritySettingsEditSection: FC<TSecuritySettingsEditSectionProps> = ({ control, googleConnected, googleEmail, hasPassword }) => {
  return (
    <InnerBox title="セキュリティ設定" padding="24px">
      <Stack gap="32px">
        <PasswordResetFields control={control} hasPassword={hasPassword} />
        <Divider sx={{ borderColor: divider.middle }} />
        {/* Passkey + external login are managed from the Detail screen; shown read-only here. */}
        <PasskeyManager embedded readOnly renderList={(props) => <PasskeyTable {...props} />} />
        <Divider sx={{ borderColor: divider.middle }} />
        <ExternalLoginSection connected={googleConnected} connectedEmail={googleEmail} disabled />
      </Stack>
    </InnerBox>
  );
};
